import Main from "./components/layout/Main";

function App() {
  return <Main />;
}

export default App;
